module.exports = __webpack_public_path__ + "img/6512.84718ae0.jpg";